/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_TotalInputs */

const vi_sinp_total = /** @type {(inputs: Sinp_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng cộng`)
};

/**

* @param {Sinp_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_total = /** @type {((inputs?: Sinp_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_total(inputs)
});